export const APP_ENV = 'production';
export const APP_DEBUG = true;
export const APP_URL = 'https://staging.drivingcalendar.com';
export const API_URL = 'https://api.staging.drivingcalendar.com';
export const CLIENT_ID = 2;
export const CLIENT_SECRET = 'UJdOP3watlmBHaCi4vCMmpJHidOn0tqNjogXCaZD';
